/* =============================================================
   TRUST BADGES — Carrusel con autoplay + loop infinito
   Activo solo en mobile/tablet (<= 999px)
   ============================================================= */

(function () {
  'use strict';

  var BREAKPOINT = 999;
  var RESUME_DELAY = 2000;

  function initSection(section) {
    var container = section.querySelector('.trust-badges__container');
    var dotsContainer = section.querySelector('.trust-badges__dots');
    if (!container || !dotsContainer) return;

    var originalCards = Array.from(container.children);
    if (originalCards.length === 0) return;

    var autoplayMs = parseInt(section.getAttribute('data-autoplay'), 10) || 4000;
    var mql = window.matchMedia('(max-width: ' + BREAKPOINT + 'px)');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var isActive = false;
    var autoplayId = null;
    var resumeTimeoutId = null;
    var isPaused = false;
    var suppressScroll = false;

    function getStep() {
      var card = container.querySelector('.trust-badges__card');
      if (!card) return 0;
      var styles = window.getComputedStyle(container);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.offsetWidth + gap;
    }

    function originalWidth() {
      return getStep() * originalCards.length;
    }

    function buildDots() {
      dotsContainer.innerHTML = '';
      originalCards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'trust-badges__dot';
        dot.setAttribute('aria-label', 'Ir al slide ' + (i + 1));
        dot.addEventListener('click', function () {
          goTo(i);
          pauseAutoplayTemporarily();
        });
        dotsContainer.appendChild(dot);
      });
      dotsContainer.removeAttribute('aria-hidden');
      dotsContainer.hidden = false;
    }

    function destroyDots() {
      dotsContainer.innerHTML = '';
      dotsContainer.setAttribute('aria-hidden', 'true');
      dotsContainer.hidden = true;
    }

    function cloneCards() {
      originalCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.classList.add('trust-badges__card--clone');
        clone.setAttribute('aria-hidden', 'true');
        container.appendChild(clone);
      });
    }

    function removeClones() {
      var clones = container.querySelectorAll('.trust-badges__card--clone');
      clones.forEach(function (c) { c.remove(); });
    }

    function currentIndex() {
      var step = getStep();
      if (step === 0) return 0;
      var origW = originalWidth();
      var pos = container.scrollLeft;
      if (origW > 0) {
        pos = ((pos % origW) + origW) % origW;
      }
      return Math.round(pos / step) % originalCards.length;
    }

    function updateDots() {
      var idx = currentIndex();
      var dots = dotsContainer.querySelectorAll('.trust-badges__dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    function goTo(index) {
      var step = getStep();
      if (step === 0) return;
      suppressScroll = true;
      container.scrollTo({ left: index * step, behavior: 'smooth' });
      setTimeout(function () { suppressScroll = false; updateDots(); }, 450);
    }

    function tick() {
      if (isPaused) return;
      var step = getStep();
      if (step === 0) return;
      var origW = originalWidth();

      // Si ya estamos dentro de la zona de clones, saltar de vuelta al inicio
      // de forma invisible antes de avanzar al siguiente.
      if (container.scrollLeft >= origW - 1) {
        suppressScroll = true;
        container.scrollTo({ left: container.scrollLeft - origW, behavior: 'auto' });
        // Forzar reflow
        void container.offsetWidth;
        suppressScroll = false;
      }

      container.scrollBy({ left: step, behavior: 'smooth' });
    }

    function startAutoplay() {
      if (prefersReducedMotion) return;
      stopAutoplay();
      autoplayId = setInterval(tick, autoplayMs);
    }

    function stopAutoplay() {
      if (autoplayId) {
        clearInterval(autoplayId);
        autoplayId = null;
      }
    }

    function pauseAutoplay() { isPaused = true; }
    function resumeAutoplay() { isPaused = false; }

    function pauseAutoplayTemporarily() {
      pauseAutoplay();
      clearTimeout(resumeTimeoutId);
      resumeTimeoutId = setTimeout(resumeAutoplay, RESUME_DELAY);
    }

    function onScroll() {
      if (suppressScroll) return;
      updateDots();

      // Si el usuario (o el autoplay) se pasó bastante dentro de los clones,
      // resetear scrollLeft en silencio para mantener la ilusión de loop.
      var origW = originalWidth();
      if (origW > 0 && container.scrollLeft >= origW * 1.5) {
        suppressScroll = true;
        container.scrollTo({ left: container.scrollLeft - origW, behavior: 'auto' });
        requestAnimationFrame(function () { suppressScroll = false; });
      }
    }

    function onPointerDown() { pauseAutoplay(); }
    function onPointerUp() { pauseAutoplayTemporarily(); }
    function onMouseEnter() { pauseAutoplay(); }
    function onMouseLeave() { resumeAutoplay(); }
    function onVisibility() {
      if (document.hidden) pauseAutoplay();
      else resumeAutoplay();
    }

    function activate() {
      if (isActive) return;
      isActive = true;
      cloneCards();
      buildDots();
      updateDots();
      startAutoplay();
      container.addEventListener('scroll', onScroll, { passive: true });
      container.addEventListener('pointerdown', onPointerDown);
      container.addEventListener('pointerup', onPointerUp);
      container.addEventListener('pointercancel', onPointerUp);
      container.addEventListener('mouseenter', onMouseEnter);
      container.addEventListener('mouseleave', onMouseLeave);
      document.addEventListener('visibilitychange', onVisibility);
    }

    function deactivate() {
      if (!isActive) return;
      isActive = false;
      stopAutoplay();
      clearTimeout(resumeTimeoutId);
      resumeTimeoutId = null;
      container.removeEventListener('scroll', onScroll);
      container.removeEventListener('pointerdown', onPointerDown);
      container.removeEventListener('pointerup', onPointerUp);
      container.removeEventListener('pointercancel', onPointerUp);
      container.removeEventListener('mouseenter', onMouseEnter);
      container.removeEventListener('mouseleave', onMouseLeave);
      document.removeEventListener('visibilitychange', onVisibility);
      removeClones();
      destroyDots();
      container.scrollLeft = 0;
    }

    function handleViewportChange() {
      if (mql.matches) activate();
      else deactivate();
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', handleViewportChange);
    } else if (mql.addListener) {
      mql.addListener(handleViewportChange);
    }

    handleViewportChange();

    // Reajustar al cargar imagenes / cambiar layout
    window.addEventListener('load', function () {
      if (isActive) updateDots();
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-trust-badges-carousel]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Reinicializar cuando el editor de Shopify re-renderiza la seccion
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-trust-badges-carousel]');
    if (section) initSection(section);
  });
})();
